module.exports = __webpack_public_path__ + "img/22_33.36578309.png";